import TabsUI from "@/shared/components/atoms/TabsUI";
import { Badges } from "@/shared/components/molecules/Badges";
import Notes from "@/shared/components/molecules/Notes";
import Stacked from "@/shared/components/molecules/Stacked";
import { t } from "i18next";

export const LeadNotePage = () => {
  const task = t("lead.views.tasks");
  const notes = t("lead.views.notes");
  const businessStage = t("lead.views.business_stage_registration");
  const tabs = [
    {
      name: task,
      href: "/leads/tasks",
      current: true,
    },
    {
      name: notes,
      href: "/leads/notes",
      current: false,
    },
    {
      name: businessStage,
      href: "/leads/business-stage",
      current: false,
    },
  ];
  return (
    <div className="mx-auto  px-4 py-8 sm:px-6 lg:px-8">
      <div className="mx-auto grid max-w-2xl grid-cols-1 grid-rows-1 items-start gap-x-8 gap-y-8 lg:mx-0 lg:max-w-none lg:grid-cols-3">
        <Stacked />
        <div className="flex-1 col-start-2 col-end-4">
          <div className="px-4">
            <TabsUI tabs={tabs} />
          </div>
          <div className="mt-1   w-full">
            <Notes />
          </div>
        </div>
      </div>
    </div>
  );
};
